import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';
import { Publish } from 'src/Shared/EventPublisher/EventEmitter';
import { Button } from '../Button';

export const MoreOptionsButton = ({ id }: { id: string }) => {
  const onMoreOptionsButtonClick: EventListener = async (evt: Event) => {
    evt.preventDefault();
    Publish(ConsentEventType.REQUEST_SHOW_PREFERENCES_LAYER);
  };

  return (
    <Button
      onClick={onMoreOptionsButtonClick}
      id={id}
      class="privacy-prompt-button secondary-button options-button"
      translationKey="options_button"
    />
  );
};
